function unwrapShopifyBlockWrappers(wrapperEl) {
  Array.prototype.slice.call(wrapperEl.children).forEach(function (child) {
    if (child.classList && child.classList.contains('shopify-block')) {
      while (child.firstChild) {
        wrapperEl.insertBefore(child.firstChild, child);
      }
      wrapperEl.removeChild(child);
    }
  });
}

function initNewLandingImagesSliderWithData(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var sliders = scope.querySelectorAll('.new-landing-images-slider-with-data__swiper');

  sliders.forEach(function (el) {
    if (el.swiper) return;

    var compactDesktop = !!el.closest('.new-landing-images-slider-with-data--compact-desktop');
    var wrapperEl = el.querySelector('.swiper-wrapper');
    if (wrapperEl) unwrapShopifyBlockWrappers(wrapperEl);

    new Swiper(el, {
      slidesPerView: 2.1,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      scrollbar: {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      navigation: {
        prevEl: el.querySelector('.new-landing-images-slider-with-data__prev'),
        nextEl: el.querySelector('.new-landing-images-slider-with-data__next'),
      },
      breakpoints: {
        0: {
          slidesPerView: 1.7,
          spaceBetween: 12,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
        750: {
          slidesPerView: compactDesktop ? 2.35 : 2.1,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
        1200: {
          slidesPerView: compactDesktop ? 2.8 : 2.1,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
      },
    });
  });
}

function normalizeToggleName(name) {
  return (name || '').trim().toLowerCase();
}

// With "Dynamic Sliders" on, only the group whose Toggle Name matches the
// active NL Video Tabs Slider tab is shown. Falls back to the first group
// when nothing matches (e.g. before the tabs slider has initialised).
function applyDynamicSliders(name) {
  var activeName = normalizeToggleName(name);

  document.querySelectorAll('.new-landing-images-slider-with-data--dynamic').forEach(function (section) {
    var groups = Array.prototype.slice.call(section.querySelectorAll('.new-landing-images-slider-with-data__block'));
    if (!groups.length) return;

    var match = groups.filter(function (group) {
      return activeName && normalizeToggleName(group.dataset.toggleName) === activeName;
    })[0] || groups[0];

    groups.forEach(function (group) {
      var isActive = group === match;
      group.classList.toggle('is-toggle-active', isActive);

      var swiperEl = group.querySelector('.new-landing-images-slider-with-data__swiper');
      if (isActive && swiperEl && swiperEl.swiper) swiperEl.swiper.update();
    });
  });
}

document.addEventListener('nl-video-tabs:change', function (event) {
  applyDynamicSliders(event.detail && event.detail.name);
});

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingImagesSliderWithData(document);
  applyDynamicSliders(window.nlVideoTabsActiveName);
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingImagesSliderWithData(event.target);
  applyDynamicSliders(window.nlVideoTabsActiveName);
});

document.addEventListener('shopify:block:select', function (event) {
  initNewLandingImagesSliderWithData(document);

  // In the theme editor, reveal a hidden group when it's selected.
  var group = event.target.querySelector
    ? event.target.querySelector('.new-landing-images-slider-with-data__block') || event.target.closest('.new-landing-images-slider-with-data__block')
    : null;
  if (group && group.closest('.new-landing-images-slider-with-data--dynamic')) {
    applyDynamicSliders(group.dataset.toggleName);
  }
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingImagesSliderWithData(document);
  applyDynamicSliders(window.nlVideoTabsActiveName);
}
